import React from 'react';

import { Variant, addVariants } from '@agilemd/ui-utils';

import styles from './styles.module.scss';

type LoadingIndicatorProps = {
  variants?: Variant<'small' | 'medium' | 'large'>;
};

/**
 * A LoadingIndicator is useful as something to show the user while a large section or page is loading data it needs to render
 */
const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ variants = ['medium'] }) => (
  <div className={addVariants('aglmd-loading-indicator', styles, variants)}>
    <div className={addVariants('aglmd-loading-indicator__bar', styles, variants)} />
    <div className={addVariants('aglmd-loading-indicator__bar', styles, variants)} />
    <div className={addVariants('aglmd-loading-indicator__bar', styles, variants)} />
  </div>
);
export default LoadingIndicator;
